/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface AvailableUpdatePackageInfo
 */
export interface AvailableUpdatePackageInfo {
    /**
     * 
     * @type {string}
     * @memberof AvailableUpdatePackageInfo
     */
    version?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableUpdatePackageInfo
     */
    releaseNotesSummary?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableUpdatePackageInfo
     */
    releaseNotesUri?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableUpdatePackageInfo
     */
    releaseDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableUpdatePackageInfo
     */
    eulaUri?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableUpdatePackageInfo
     */
    $type?: AvailableUpdatePackageInfoTypeEnum;
}


/**
 * @export
 */
export const AvailableUpdatePackageInfoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCsoPortalDtoAvailableUpdatePackageInfoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.CsoPortal.Dto.AvailableUpdatePackageInfo, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type AvailableUpdatePackageInfoTypeEnum = typeof AvailableUpdatePackageInfoTypeEnum[keyof typeof AvailableUpdatePackageInfoTypeEnum];



/**
 * Check if a given object implements the AvailableUpdatePackageInfo interface.
 */
export function instanceOfAvailableUpdatePackageInfo(value?: unknown): value is AvailableUpdatePackageInfo {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(AvailableUpdatePackageInfoTypeEnum)[0];
}

export function AvailableUpdatePackageInfoFromJSON(json: any): AvailableUpdatePackageInfo {
    return AvailableUpdatePackageInfoFromJSONTyped(json, false);
}

export function AvailableUpdatePackageInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableUpdatePackageInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'version': json['version'] == null ? undefined : json['version'],
        'releaseNotesSummary': json['releaseNotesSummary'] == null ? undefined : json['releaseNotesSummary'],
        'releaseNotesUri': json['releaseNotesUri'] == null ? undefined : json['releaseNotesUri'],
        'releaseDate': json['releaseDate'] == null ? undefined : json['releaseDate'],
        'eulaUri': json['eulaUri'] == null ? undefined : json['eulaUri'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function AvailableUpdatePackageInfoToJSON(value?: AvailableUpdatePackageInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'version': value['version'],
        'releaseNotesSummary': value['releaseNotesSummary'],
        'releaseNotesUri': value['releaseNotesUri'],
        'releaseDate': value['releaseDate'],
        'eulaUri': value['eulaUri'],
        '$type': value['$type'],
    });
}

